export default "__VITE_ASSET__Cq54kTSt__"